import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Hero from './components/Hero';
import Collections from './components/Collections';
import FeaturedProducts from './components/FeaturedProducts';
import ContactInfo from './components/ContactInfo';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <Hero />
      <Collections />
      <FeaturedProducts />
      <ContactInfo />
      <Footer />
    </div>
  );
}
